module.exports = __webpack_public_path__ + "img/pic_feed_megasale_title.c7158c05.png";